import {Component, OnInit} from '@angular/core';
import {AboutUsService, IAbout} from 'projects//paid_ukr/src/app/components/about-us/about-us.service';
import {AboutUsServiceBusiness} from './about-us-business.service';

@Component({
  selector: 'app-about-us-business',
  templateUrl: './about-us-business.component.html',
  styleUrls: ['./about-us-business.component.scss']
})
export class AboutUsBusinessComponent implements OnInit {

  items: IAbout[];


  constructor(private service: AboutUsServiceBusiness) {
  }

  ngOnInit(): void {
    this.items = this.service.getList();
  }

}
